import { SystemContext } from "@/App";
import { deleteBranch, updateBranch } from "@/api/project/branch";
import { SystemStatus } from "@/commons/context/system-store";
import { Branch } from "@/commons/interface/project/branch";
import TnModal from "@/commons/widget/base-modal";
import TnInput from "@/commons/widget/input/tn-input";
import TnMessage from "@/commons/widget/message";
import { Modal } from "antd";
import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ContextMenuFC } from "tncet-common";


interface Iprops {
    branch: Branch // 分支
    onDeleteBranch: () => void // 删除了分支
    onUpdateBranch: (data: Branch) => void // 更新了分支
}

export default function BranchItem(props: Iprops) {
    const { branchUuid } = useParams();
    const { branch } = props;
    const [item, setItem] = useState<Branch>();
    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开分支的右键菜单
    const [top, setTop] = useState<number>(); // 右键菜单top
    const [left, setLeft] = useState<number>(); // 右键菜单left
    const navigate = useNavigate();
    const [editing, setEditing] = useState<boolean>(false); // 是否处于编辑状态
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        setItem(branch);
    }, [branch])

    // 打开分支
    const openBranch = () => {
        if (editing) return;
        if (!item) return;
        systemContext.setOnlyShowModelUuid('');
        navigate(`/project/${item.projectUuid}/model/${item.modelUuid}/branch/${item.uuid}`);
        systemContext.setCurrentBranchUuid(item.uuid);
    }


    // 右键分支
    const onRightClick = (e) => {
        setCmOpen(true);
        setLeft(e.clientX);
        setTop(e.clientY);
    }

    // 更新分支
    const onUpdateBranch = (uuid: string, data) => {
        updateBranch(uuid, data).then(res => {
            setItem({ ...item, ...data });
            props.onUpdateBranch({ ...item, ...data })
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    // 删除分支
    const onDeleteBranch = () => {
        if (!item) return;
        TnModal().deleteModal({
            onOk() {
                Modal.destroyAll();
                deleteBranch(item.uuid).then(res => {
                    TnMessage.success("删除成功");
                    props.onDeleteBranch();
                }).catch(() => {
                    TnMessage.error("删除失败")
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            content: `点击确认，删除${item.name}，并删除模型中的所有图元`,
            closable: true
        })
    }

    if (!item) {
        return (<div></div>)
    }

    return (
        <div className="branch-item">
            <div className={classNames({
                "branch-title": true,
                "selected": branchUuid == item.uuid,
            })} onClick={() => openBranch()} onContextMenu={(e) => { e.preventDefault(); onRightClick(e) }}>
                {editing && <TnInput
                    className="small-input"
                    defaultValue={item.name}
                    onBlur={(value) => {
                        onUpdateBranch(item.uuid, { name: value })
                        setEditing(false);
                    }}
                    onEscapeKeyDown={() => {
                        setEditing(false);
                    }}
                    onPressEnter={(value) => {
                        onUpdateBranch(item.uuid, { name: value })
                        setEditing(false);
                    }}
                />}
                {!editing && (
                    <>
                        <div className="name">
                            <span>{item.name}</span>
                        </div>
                    </>
                )}
            </div>
            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='tn-right-context-menu'
                onCancel={() => { setCmOpen(false) }}
            >
                <div className="menu-item" onClick={() => { setEditing(true); setCmOpen(false) }}>重命名</div>
                <div className="menu-item" onClick={() => { onDeleteBranch(); setCmOpen(false) }}>删除</div>
            </ContextMenuFC>
        </div>
    )
}